/**
 * WordPress dependencies
 */
import { useState, useEffect, useRef } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Button } from "@wordpress/components";
import { dispatch, useSelect, useDispatch } from '@wordpress/data';
import { parse } from '@wordpress/blocks';
import { store as blockEditorStore } from '@wordpress/block-editor';

import Masonry from "react-responsive-masonry";

import PatternContext from '../Context/PatternContext';

import PatternlyHeader from "./PatternlyHeader";
import PatternlySidebar from "./PatternlySidebar";
import PatternDependencyModal from "./PatternDependencyModal";

const PatternlyWrap = () => {
    const [error, setError] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const [queryType, setQueryType] = useState(false);
    const [queryTypeValue, setQueryTypeValue] = useState(false);

    const [patternContent, setPatternContent]  = useState('');
    const [importItem, setImportPattern]  = useState(false);
    const [importItemSlug, setImportPatternSlug]  = useState('');
    const [importAndSave, setImportAndSave]  = useState(false);
    
    const [loadFavouriteData, setLoadFavouriteData]  = useState(false);
    const [favouriteItems, setFavouriteItems] = useState([]);

    const [postType, setPostType]               = useState('page');
    const [templateData, setTemplateData]         = useState({});
    const [loadData, setLoadData] = useState(false);
    const [loadMoreButton, setLoadMoreButton]   = useState(true);
    const [letsPrintData, setLetsPrintData]     = useState(false);

    const [searchValue, setSearchValue]     = useState(false);
    const [colorValue, setColorValue]       = useState(false);
    const [licenseValue, setLicenseValue]   = useState(false);
    const [modeValue, setModeValue]         = useState(false);
    const [sectionValue, setSectionValue]   = useState(false);
    const [categoryValue, setCategoryValue] = useState(false);
    const [favouriteValue, setFavouriteValue]   = useState(false);

    const [isSingle, setIsSingle]     = useState(false);
    const [singlePageImage, setSinglePageImage]     = useState('');
    const [singlePageSlug, setSinglePageSlug]       = useState('');
    const [singlePageTitle, setSinglePageTitle]     = useState('');

    const [termData, setTermData]           = useState({});
    const [loadTermData, setLoadTermData]   = useState(false);
    const [letsPrintTermData, setLetsPrintTermData]   = useState(false);

    const [dependencyModalStatus, setDependencyModalStatus]   = useState(false);
    const [dependencyPlugins, setDependencyPlugins]   = useState('');
    const [dependencyPluginSlug, setDependencyPluginSlug]   = useState('');

    const { savePost } = useDispatch('core/editor');

    useEffect(  () => {
        if(isVisible) {
            document.querySelector('body').classList.add('pat-disable-scroll');
        }else {
            document.querySelector('body').classList.remove('pat-disable-scroll');
        }

    }, [isVisible] )

    const showLibrary = () => {
        setIsVisible(!isVisible);

        setQueryType('all');
        setLoadData(true);

        setLoadTermData(true);
    };

    const hideLibrary = () => {
        setIsVisible(!isVisible);
        setQueryType(false);

        setDependencyPluginSlug('');
        setDependencyPlugins('');
        setDependencyModalStatus(false);
        setImportAndSave(false);
    };

    const loadMorePatterns = (event) => {
        let target_page = event.currentTarget.getAttribute('target_page');
        setCurrentPage(target_page);
        setLoadData(true);
    };
    
    const previewPattern = (event) => {
        //add disable scroll class for library.
        // let libraryWrap = document.querySelector('.pat-wrapper');
        // libraryWrap.classList.add('pat-disable-scroll');

        //add active class.
        // let popupWrap = document.querySelector('.pat-popup-wrapper');
        // popupWrap.classList.add('pat-popup-active');

        //set img url to popup img.
        let patternItem = event.currentTarget.closest('.pat-item-background');
        let patternItemImg = patternItem.querySelector('img');
        let imageURL = patternItemImg.getAttribute('src');
        // let popupImg = document.querySelector('.pat-popup-item-wrapper img');
        // popupImg.src = imageURL;

        //set slug to import button.
        let slug = event.currentTarget.getAttribute('slug');
        let license = event.currentTarget.getAttribute('license');
        let title = event.currentTarget.getAttribute('templateTitle');

        // let popupImportBtn = document.querySelector('.pat-popup-header .pat-import-button');
        // popupImportBtn.setAttribute('slug', slug);

        // if(license == 'pro') {
        //     if(PatLocalize.is_pro_activated.length === 0) {
        //         popupImportBtn.style.display = 'none';
        //     }
        // }else {
        //     popupImportBtn.style.display = 'flex';
        // }

        setSinglePageImage(imageURL);
        setSinglePageSlug(slug);
        setSinglePageTitle(title);
        setIsSingle(true);

    };
    
    const hidePreviewPattern = (event) => {
        //remove disable scroll class for library.
        let libraryWrap = document.querySelector('.pat-wrapper');
        libraryWrap.classList.remove('pat-disable-scroll');

        //remove active class.
        let popupActive = document.querySelector('.pat-popup-active');
        popupActive.classList.remove('pat-popup-active');
    };
    
    const syncLibrary = (event) => {
        setQueryType('all');
        setQueryTypeValue(false);
        setCurrentPage(1);
        setLoadData(true);
        setLoadTermData(true);
    };

    const saveAsFavourite = (event) => {
        //pattern slug.
        let patItem = event.target.closest('.pat-item-background');
        let itemSlug = patItem.getAttribute('data-slug');

        if(!itemSlug) {
            return;
        }

        //api data.
        let data = {
            'nonce': PatLocalize.nonce,
            'post_type': postType,
            'template_slug': itemSlug,
        };

        fetch(PatLocalize.save_as_fav_api_url, {
            method: "POST",
            body: JSON.stringify(data)
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if (data) {
                //add favourite class to the item.
                patItem.classList.add('pat-fav-pattern');
            }
        })
        .catch((error) => {
            console.log('-- after favourite item is saved: error() --');
            console.error(error);
        });
    }

    const backToLibrary = (event) => {
        event.preventDefault();

        setIsSingle(false);
    }

    //get term data.
    useEffect(  () => {

        async function fetchTermAPIData() {
            if(loadTermData) {
                await getTermData();
            }
        }

        fetchTermAPIData();

    }, [termData, loadTermData] )

    //get pattern data.
    useEffect( () => {

        async function fetchAPIData() {
            if(currentPage && loadData) {
                await getData();
            }
        }

        fetchAPIData();

    }, [queryType, loadData, currentPage] )

    //get favourite data.
    useEffect( () => {

        async function fetchFavAPIData() {
            if(loadFavouriteData) {
                await getFavouriteData();
            }
        }

        fetchFavAPIData();

    }, [loadFavouriteData] )
    
    //get pattern content.
    useEffect( () => {

        async function fetchPatternContent() {

            if(importItem && importItemSlug) {
                await getContent();
            }
            
        }

        fetchPatternContent();

    }, [importItem, importItemSlug] )

    async function getTermData(url = '') {

        if( ! PatLocalize.pat_plugin_url ) {
            return;
        }

        if( !url ) {
            url = PatLocalize.pat_plugin_url + 'src/json/template-terms.json';
        }

        let patSidebar = document.querySelector(".pat-sidebar");
        if(patSidebar) {
            patSidebar.classList.add('pat-skeleton-sidebar-active');
        }

        await Promise.all([
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'Cache-Control': 'no-cache'
                },
            })
            .then(function(response) {
                return response.json();
            })
            .then( function(response) {
                setTermData(response);

                if(patSidebar) {
                    patSidebar.classList.remove('pat-skeleton-sidebar-active');
                }
            })
        ]);

        setLetsPrintTermData(true);
        setLoadTermData(false);
    }

    async function getData(apiURL = '') {

        if( ! PatLocalize.remoteurl ) {
            return;
        }

        if( !apiURL ) {

            if(queryType === 'all' && currentPage === 1) {
                apiURL = PatLocalize.pat_plugin_url + 'src/json/default-'+ postType +'-templates.json';
            }else {
                //@TODO need to change 'homeurl' to 'remoteurl'.
                const url       = new URL(PatLocalize.remoteurl + "/wp-json/optemiz/v1/patternly/templates");
                const params    = new URLSearchParams(url.search);

                params.set('post_type', postType);

                if(searchValue) {
                    params.set('search', searchValue);
                }else {
                    params.delete('search');
                }
                
                if(colorValue) {
                    params.set('color', colorValue);
                }else {
                    params.delete('color');
                }
                
                if(licenseValue) {
                    params.set('license', licenseValue);
                }else {
                    params.delete('license');
                }
                
                if(modeValue) {
                    params.set('mode', modeValue);
                }else {
                    params.delete('mode');
                }
                
                if(categoryValue) {
                    params.set('category', categoryValue);
                }else {
                    params.delete('category');
                }
                
                if(sectionValue) {
                    params.set('section', sectionValue);
                }else {
                    params.delete('section');
                }
                
                if(favouriteValue) {
                    params.set('favourite', favouriteValue);
                }else {
                    params.delete('favourite');
                }

                if(currentPage > 1) {
                    params.set('page', currentPage);

                    if(templateData['data'].length > 0) {
                        let ids = templateData['data'].map((item) => {
                            return item.id;
                        });
        
                        var serializedIds = JSON.stringify(ids);

                        params.set('exclude_posts', serializedIds);
                    }
                }
                
                //set final params.
                url.search  = params.toString();

                //set final url.
                apiURL      = url.toString();
            }

            // display loader.
            let entryContent = document.querySelector('.pat-grid-items-entry-content');

            if(entryContent) {
                entryContent.classList.add('pat-skeleton-grid-items-active');
            }

            // display sync loader.
            let syncBtn = document.querySelector('.pat-sync-btn');

            if(syncBtn) {
                syncBtn.classList.add('pat-sync-btn-active');
            }
        }

        await Promise.all([
            fetch(apiURL, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(function(response) {
                return response.json();
            })
            .then( function(response) {
                let oldData = templateData['data'];
                let newData = response['data'];

                if(oldData && currentPage > 1) {
                    response['data'] = [...oldData, ...newData];
                }

                if(response['load_more'] == 'no') {
                    setLoadMoreButton(false);
                }

                setTemplateData(response);

                let waitTime = 0;
                if(queryType !== 'all') {
                    waitTime = 200;
                }

                setTimeout(function() {

                    // hide loader.
                    let entryContent = document.querySelector('.pat-grid-items-entry-content');

                    if(entryContent) {
                        entryContent.classList.remove('pat-skeleton-grid-items-active');
                    }
    
                    // hide sync loader.
                    let syncBtn = document.querySelector('.pat-sync-btn');

                    if(syncBtn) {
                        syncBtn.classList.remove('pat-sync-btn-active');
                    }

                }, waitTime);
            })
        ]);

        setLetsPrintData(true);
        setLoadData(false);
    }

    /**
     * Get farourite patterns
     * 
     * @param {string} url Api URL 
     * 
     * @returns mixed
     */
    async function getFavouriteData() {

        if( ! PatLocalize.homeurl ) {
            return;
        }

        let url = PatLocalize.homeurl + "/wp-json/optemiz/v1/patternly/get-favourite-templates";

        //api data.
        let data = {
            'nonce': PatLocalize.nonce,
            'post_type': postType
        };

        await Promise.all([
            fetch(url, {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(function(response) {
                return response.json();
            })
            .then( function(response) {

                // console.log(response);
                
                setFavouriteValue(response.templates);
                setQueryType(false);
                setLoadData(true);

                setLoadFavouriteData(false);
            })
        ]);
    }
    
    /**
     * Get template content.
     * 
     * @param {string} apiURL  API URL
     * 
     * @returns mixed
     */
    async function getContent(apiURL = '') {

        if( ! PatLocalize.homeurl ) {
            return;
        }

        if( !apiURL ) {

            const url       = new URL(PatLocalize.homeurl + "/wp-json/optemiz/v1/patternly/get_template");
            const params    = new URLSearchParams(url.search);

            //add slug to the URL.
            if(importItemSlug.length > 0) {
                params.set('template_slug', importItemSlug);
                params.set('post_type', postType);

                //set final params.
                url.search  = params.toString();

                //set final url.
                apiURL  = url.toString();
            }
        }

        await Promise.all([
            fetch(apiURL, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(function(response) {
                return response.json();
            })
            .then( function(response) {

                if(response.content.length > 0) {
                    let parsedBlocks = parse(response.content);

                    //insert blocks.
                    dispatch( blockEditorStore ).insertBlocks( parsedBlocks );

                    if(!importAndSave) {
                        hideLibrary();
                    }

                    if(importAndSave) {
                        //save the post.
                        savePost();
                        hideLibrary();
                    }

                }

                // enable items after importing.
                let patItems = document.querySelectorAll('.pat-item-background');
                if(patItems) {
                    patItems.forEach( patItem => {
                        if(patItem) {
                            patItem.classList.remove('pat-item-disable');
                        }
                    })
                }

            })
        ]);

        setImportPattern(false);
        setImportPatternSlug('');
        setImportAndSave(false);
    }

    function getTemplateContent(event) {
        event.preventDefault();

        let importButton = event.target;

        if(!importButton.classList.contains('pat-import-button')) {
            importButton = importButton.parentElement;
        }

        let patItem         = importButton.closest('.pat-item');
        let dependencies    = patItem.getAttribute('data-dependency');
        let patternSlug     = patItem.getAttribute('data-slug');

        // Check dependecy plugins are activated or not, display dependency modal if needed.
        if(PatLocalize.activated_plugins && dependencies && dependencies.length > 0) {
            let dependenciesList = dependencies.split(',');

            //check if any of the dependency plugin is previously activated or not.
            let anyPluginIsNotActivated = dependenciesList.some(value => !PatLocalize.activated_plugins.includes(value));

            if(anyPluginIsNotActivated) {
                setDependencyPluginSlug(patternSlug);
                setDependencyPlugins(dependencies);
                setDependencyModalStatus(true);
                return;
            }
        }

        importButton.querySelector('span').innerText = __('Importing...', 'patternly');

        // Disable other items when importing.
        let patItems = document.querySelectorAll('.pat-item-background');
        if(patItems) {
            let patCurrentItem = importButton.closest('.pat-item-background');

            patItems.forEach( patItem => {
                if(patItem !== patCurrentItem) {
                    if(patItem) {
                        patItem.classList.add('pat-item-disable');
                    }
                }
            })
        }

        let slug = importButton.getAttribute('slug');

        if(slug) {
            setImportPattern(true);
            setImportPatternSlug(slug);
        }

    }

    function formatUrl(url) {
        //check if `?` mark exist in the URL or not.
        if(!url.includes('?')) {
            url += "?";
        }else {
            url += "&";
        }

        return url;
    }

    function renderItem() {
        if(templateData && letsPrintData) {
            
            return(
                templateData['data'].map(item => {
                    let itemImage       = '';
                    let className       = 'pat-item-background pat-item';
                    let isProPattern    = false;
                    let patternLicense  = 'free';
                    
                    if(!PatLocalize.is_pro_activated) {

                        if(!("license" in item)) {
                            item.license = 'free';
                        }

                        if (item.license.length > 0 && item.license === "pro") {
                            className += ' pro-badge';
                            isProPattern = true;
                            patternLicense = 'pro';
                        }
                    }

                    //check if favourite pattern.
                    if(favouriteItems.includes(item.slug)) {
                        className += ' pat-fav-pattern';
                    }

                    let defaultData = PatLocalize.default_page_data;
                    if('pattern' === postType) {
                        defaultData = PatLocalize.default_pattern_data;
                    }
                    
                    if(defaultData.includes(item.slug)) {
                        if(item.thumbnail.includes(PatLocalize.remoteurl)) {
                            itemImage = item.thumbnail;
                        }else {
                            itemImage = PatLocalize.pat_plugin_url + 'src/admin/assets/images/template-thumbnails/' + postType + '/' + item.thumbnail;
                        }
                    }else {
                        itemImage = item.thumbnail;
                    }

                    let patBtn = <a 
                    class="pat-hover-import-button pat-hover-btn pat-import-button" 
                    onClick={getTemplateContent}
                    slug={item.slug}>
                        <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/downloading.png`} alt="" />
                        <span>{__('Import', 'patternly')}</span>
                    </a>

                    if(isProPattern) {
                        patBtn = <a 
                        class="pat-hover-import-button pat-hover-btn pat-import-button"
                        href={PatLocalize.pat_pro_url}
                        slug={item.slug}>
                            <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/gift.png`} alt="" />
                            <span>{__('Get Pro', 'patternly')}</span>
                        </a>
                    }
    
                    return(
                        <div className={className} 
                            data-slug={item.slug}
                            data-license={item.license}
                            data-category={item.category}
                            data-tag={item.tag}
                            data-dependency={item.dependency_plugins}
                            >
                            
                            <div className="pat-item-image">
                                <img src={itemImage} alt={item.title} />
                            </div>

                            <div className="pat-item-title">
                                <h3>{item.title}</h3>
                            </div>

                            <a 
                            class="pat-favourite-icon"
                            onClick={saveAsFavourite}
                            >
                                <svg width="18" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5Z" fill="url(#paint0_linear_489_819)"/>
                                    <defs>
                                    <linearGradient id="paint0_linear_489_819" x1="10.0059" y1="-1.15276" x2="10.0059" y2="18.4082" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#F1693C"/>
                                    <stop offset="1" stop-color="#F13F05"/>
                                    </linearGradient>
                                    </defs>
                                </svg>
                            </a>
    
                            <div class="pat-hover-buttons">
                                {patBtn}
                                <a 
                                class="pat-hover-preview-button pat-hover-btn" 
                                onClick={previewPattern} 
                                license={patternLicense}
                                templateTitle={item.title}
                                slug={item.slug}>
                                    <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/eye.png`} alt="" />
                                    <span>{__('Preview', 'patternly')}</span>
                                </a>
                            </div>
                        </div>
                    )
                })
            )
        }
    }

    /**
     * Returns `true` if the post is done saving, `false` otherwise.
     *
     * @returns {Boolean}
     */
    const useAfterSave = () => {
        const [ isPostSaved, setIsPostSaved ] = useState( false );
        const isPostSavingInProgress = useRef( false );
        const { isSavingPost, isAutosavingPost } = useSelect( ( __select ) => {
            return {
                isSavingPost: __select( 'core/editor' ).isSavingPost(),
                isAutosavingPost: __select( 'core/editor' ).isAutosavingPost(),
            }
        } );

        useEffect( () => {
            if ( ( isSavingPost || isAutosavingPost ) && ! isPostSavingInProgress.current ) {
                setIsPostSaved( false );
                isPostSavingInProgress.current = true;

                let importBtn = document.querySelector('.pat-proceed-import-btn span');
                importBtn.innerText = __('Pattern saving...', 'patternly');
            }

            if ( ! ( isSavingPost || isAutosavingPost ) && isPostSavingInProgress.current ) {
                // Code to run after post is done saving.
                setIsPostSaved( true );
                isPostSavingInProgress.current = false;
            }
        }, [ isSavingPost, isAutosavingPost ] );

        return isPostSaved;
    }

    return (
        <>
            <Button
                className={"pat-library-button"}
                onClick={() => showLibrary()}
            >
                <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/logo-white.png`} alt="Patternly" />
            </Button>

            {isVisible && (
                <PatternContext.Provider 
                value={{
                    templateData, 
                    loadData, 
                    termData, 
                    letsPrintTermData, 
                    setCurrentPage,

                    setSearchValue,
                    setColorValue,
                    setLicenseValue,
                    setModeValue,
                    setSectionValue,
                    setCategoryValue,
                    setFavouriteValue,

                    setQueryType, 
                    setQueryTypeValue, 
                    setLoadData, 
                    setLoadMoreButton,
                    setLoadFavouriteData,
                    dependencyModalStatus,
                    setDependencyModalStatus,
                    dependencyPlugins,
                    setDependencyPlugins,
                    dependencyPluginSlug, 
                    setDependencyPluginSlug,
                    setImportAndSave,
                    setImportPattern,
                    setImportPatternSlug,
                    useAfterSave,
                    postType, 
                    setPostType,
                    setLoadTermData
                    }}>
                    <div class="pat-wrapper">
                        <div class="pat-header">
                            <div class="pat-logo">
                                <a href={PatLocalize.pat_pro_url}>
                                    <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/logo.png`} alt="Patternly" />
                                </a>
                            </div>
                            
                            <div class="pat-header-wrapper">
                                {
                                    !isSingle && (
                                        <a class="pat-header-btn pat-sync-btn" onClick={(syncLibrary)}>
                                            <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/sync.png`} alt="" />
                                            <span>{__('Sync', 'patternly')}</span>
                                        </a>
                                    )
                                }

                                {!isSingle && !PatLocalize.is_pro_activated && (
                                    <a class="pat-header-btn pat-pro-btn" href={PatLocalize.pat_pro_url}>
                                        <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/gift.png`} alt="" />
                                        <span>{__('Upgrade to Pro', 'patternly')}</span>
                                    </a>
                                ) }

                                {isSingle && (
                                    <a 
                                    class="pat-header-btn pat-pro-btn pat-import-button" 
                                    onClick={getTemplateContent}
                                    slug={singlePageSlug}>
                                        <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/downloading.png`} alt="" />
                                        <span>{__('Import', 'patternly')}</span>
                                    </a>
                                )}

                                <a class="pat-header-icon" href={PatLocalize.pat_pro_url}> <img class="close-btn" src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/info.png`} alt="" /></a>
                                <a class="pat-header-icon pat-hide-library" href="#" onClick={() => hideLibrary()}><img class="close-btn" src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/close.png`} alt="" /></a>
                            </div>
                        </div>

                        <div class="pat-body">
                            
                            <PatternDependencyModal />

                            { !isSingle && (
                                <div className="pat-body-inner">
                                    <PatternlySidebar />

                                    <div class="pat-main">
                                        <PatternlyHeader />

                                        <div class="pat-grid-items-entry-content">
                                            <div class="pat-grid-items-background">
                                                <Masonry columnsCount={3} gutter="30px">
                                                    {renderItem()}
                                                </Masonry>
                                            </div>

                                            <div class="pat-skeleton-grid-items-background">
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                                <div class="pat-skeletion-grid-item"></div>
                                            </div>
                                        </div>
                                        
                                        <div class="pat-load-more-btn-wrapper">
                                            {templateData && loadMoreButton && letsPrintData && (
                                                <a class="pat-load-more-btn" 
                                                onClick={loadMorePatterns}
                                                current_offset={templateData['offset']}
                                                target_page={templateData['current_page'] + 1}
                                                >{__('Load More', 'patternly')}</a>
                                            )}
                                        </div>
                                        
                                        
                                        
                                    </div>
                                </div>
                            ) }

                            { isSingle && (
                                <div class="pat-single-item-wrapper">
                                    <div class="pat-single-page-header">
                                        <a class="pat-single-page-back-btn" onClick={backToLibrary}>
                                            <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.99625 -0.0097652C10.1951 -0.00951896 10.3894 0.0499998 10.5542 0.161188C10.7191 0.272376 10.8471 0.430185 10.9218 0.614457C10.9965 0.798728 11.0146 1.0011 10.9738 1.19571C10.933 1.39032 10.835 1.56834 10.6925 1.70703L3.39957 9L10.6925 16.293C10.7885 16.3851 10.8651 16.4955 10.9179 16.6176C10.9707 16.7397 10.9986 16.8712 10.9999 17.0042C11.0013 17.1373 10.9761 17.2692 10.9258 17.3924C10.8755 17.5156 10.8012 17.6275 10.7071 17.7216C10.613 17.8157 10.5011 17.89 10.3779 17.9403C10.2547 17.9906 10.1228 18.0158 9.98972 18.0144C9.85668 18.0131 9.72525 17.9852 9.60312 17.9324C9.48099 17.8796 9.37062 17.803 9.27848 17.707L1.27848 9.70703C1.09101 9.51949 0.9857 9.26517 0.9857 9C0.9857 8.73483 1.09101 8.48051 1.27848 8.29297L9.27848 0.292969C9.37178 0.197057 9.48338 0.120844 9.60667 0.0688431C9.72997 0.0168425 9.86244 -0.00988797 9.99625 -0.0097652Z" fill="#717D86"/>
                                            </svg>
                                        </a>

                                        <h2>{singlePageTitle}</h2>
                                    </div>

                                    <div class="pat-single-body">
                                        <div class="pat-single-browser-header">
                                            <div class="pat-browser-dotted">
                                                <span class="pat-browser-dotted-item"></span>
                                                <span class="pat-browser-dotted-item"></span>
                                                <span class="pat-browser-dotted-item"></span>
                                            </div>
                                        </div>

                                        <img src={singlePageImage} />

                                    </div>
                                </div>
                            ) }

                        </div>
                    </div>
                </PatternContext.Provider>
                
            )}
        </>
    );
};

export default PatternlyWrap;